export default function getImage(image, size) {
  const { path } = image;
  const tabbed = path.split("/");
  tabbed[tabbed.length - 1] = size + "_" + tabbed[tabbed.length - 1];
  return tabbed.join("/");
}
